module.exports = {
  preRouteUrl: '/apps',
};
